import { NikeDwh } from '../../types/generated/nike-dwh-api';
import axios from 'axios';
import { getLastLoggedInCustomerId } from '../../common/logging/utils';
import { trackEventGA4 } from '../gtm';

export const trackVideoStart = async ({
    articleId = window.location.pathname,
    provider,
    sport,
    sportEventId,
    sportId,
    videoId
}: Partial<Omit<NikeDwh.DwhStreamEventReqV2DTO, 'startTime' | 'endTime' | 'customerId'>>) => {
    await axios.post<never, string>('/api/dwh/stream-event', {
        customerId: getLastLoggedInCustomerId(),
        startTime: Date.now(),
        endTime: 0,
        articleId,
        provider,
        sport,
        sportEventId,
        sportId,
        videoId
    });

    await trackEventGA4('video_start', {
        video_current_time: '0',
        video_duration: '0',
        video_percent: '0',
        video_provider: provider,
        video_title: articleId,
        video_url: videoId,
        visible: true,
        sport,
        sport_event_id: sportEventId,
        sport_id: sportId
    });
};

export const trackVideoVolume = async ({ volume, muted }) => {
    await trackEventGA4('video_volume', { video_volume: volume, video_muted: muted });
};
